import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Button, Flex, Input, Select, Typography, Upload } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { servicesAction } from 'src/store/Slices/Administrator/ServicesSlice';
import { UploadOutlined } from '@ant-design/icons';


const AddEditServiceModal = ({ visible, setVisible, serviceInfo, setPage, setPageSize }) => {

    const dispatch = useDispatch()
    const items = [
        {label : 'Да', value : 1},
        {label : 'Нет', value: 0}
    ]

    const [name, setName] = useState()
    const [description, setDescription] = useState()
    const [imgUrl, setImgUrl] = useState()
    const [isPersonal, setIsPersonal] = useState()
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false)


    useEffect(() => {
        setName()
        setDescription()
        setImgUrl()
        setIsPersonal()
        setFileList([])
    }, [visible.flag])


    useEffect(() => {
        if (visible.flag === 'edit') {
            setName(serviceInfo?.name)
            setDescription(serviceInfo?.description)
            setImgUrl(serviceInfo?.imageUrl?.props?.src)
            setIsPersonal(serviceInfo?.isPersonal ? 1 : 0)
            setFileList([])
        }
    }, [visible, serviceInfo])

    const onClickSubmit = () => {
        const formData = new FormData();
            fileList.forEach((file) => {
                formData.append('imageFile', file);
            });
        formData.append('id', visible.flag !== 'add' ? serviceInfo.id : undefined)
        formData.append('name', name)
        formData.append('description', description)
        formData.append('imageUrl', imgUrl)
        formData.append('isPersonal', !!isPersonal)
        setUploading(true)
        dispatch(servicesAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: formData
        })).then(() => {
            dispatch(servicesAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
                setPage(1)
                setPageSize(20)
                setUploading(false)
            })
        })
    }

    const handleChange = (info) => {
        if (info.fileList.length === 0) {
            setFileList([])
        } else {
            let newFileList = [...fileList];
            newFileList = newFileList.slice(-1);

            setFileList(newFileList);
        }
 
    };

    const props = {
        onRemove: () => {
            setFileList([])
        },
        onChange: handleChange,
        beforeUpload: (file) => {
            if (file.size > 1048576) {
                openNotification({
                    type: 'error',
                    message: 'Размер файла должен быть меньше одного мегабайта'
                })
                return false
            }
            setFileList([...fileList, file]);
            return false;
        },
        fileList,
    };


    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить услугу' : 'Редактировать услугу'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Наименование</Typography.Title>
                            <Input
                                value={name}
                                onChange={e => setName(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Описание</Typography.Title>
                            <Input
                                value={description}
                                onChange={e => setDescription(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Ссылка на изображение</Typography.Title>
                            <Input
                                value={imgUrl}
                                onChange={e => setImgUrl(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Персональная</Typography.Title>
                            <Select
                                style={{ width: '100%' }}
                                value={isPersonal}
                                onChange={e => setIsPersonal(e)}
                                options={items}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Изображение (размер меньше 1 МБ)</Typography.Title>
                            <Upload accept='.png,.jpg,.jpeg' {...props}>
                                <Button icon={<UploadOutlined />}>Выберите файл</Button>
                            </Upload>
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton disabled={uploading} onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditServiceModal